import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Overline } from "./primitives";
import { TESTIMONIALS } from "./content";

const EASE = [0.16, 1, 0.3, 1];

export default function SocialProof() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];

  return (
    <section data-testid="social-proof-section" className="relative bg-forest py-28 text-warm md:py-44">
      <div className="mx-auto max-w-[1300px] px-6 text-center md:px-12">
        <Overline className="text-champagne">In Their Words</Overline>

        <div className="relative mt-12 min-h-[320px] md:min-h-[280px]">
          <span className="pointer-events-none absolute -top-10 left-1/2 -translate-x-1/2 font-serif text-[10rem] leading-none text-champagne/25 md:text-[16rem]">
            &ldquo;
          </span>
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.7, ease: EASE }}
              className="relative"
            >
              <p className="mx-auto max-w-[26ch] font-serif text-3xl italic leading-tight sm:text-4xl lg:text-5xl">
                {t.quote}
              </p>
              <footer className="mt-10">
                <p className="font-serif text-xl">{t.name}</p>
                <p className="overline mt-1 text-champagne">{t.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center justify-center gap-3">
          {TESTIMONIALS.map((_, idx) => (
            <button
              key={idx}
              data-testid={`testimonial-dot-${idx}`}
              onClick={() => setI(idx)}
              className={`h-2 rounded-full transition-all duration-500 ${
                idx === i ? "w-8 bg-champagne" : "w-2 bg-warm/30 hover:bg-warm/60"
              }`}
              aria-label={`Testimonial ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
